var React = require('react');

function Pochon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.5 7.5C6 9.5 5 13 5 16.5V20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3.5c0-3.5-1-7-3.5-9","key":0}),React.createElement("path",{"d":"M8.5 7.5L7.5 3.5h9l-1 4","key":1}),React.createElement("path",{"d":"M8.5 7.5h7","key":2}),React.createElement("path",{"d":"M11 7.5c-.5 2-1.5 3-2.5 3.5M13 7.5c.5 2 1.5 3 2.5 3.5","key":3})]);
}

Pochon.defaultProps = {"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = Pochon;

Pochon.default = Pochon;
